export default __webpack_public_path__ + "static/media/loc_img_5.ab2db221.jpg";